(function () {
  const IMG_SIZES = '(max-width: 600px) 100vw, (max-width: 960px) 50vw, 600px';

  function updateHeroPreload(payload) {
    const preload = document.getElementById('mixersHeroPreload');
    if (!preload || !payload?.src) return;
    preload.href = payload.src.replace(/width=\d+/i, 'width=800');
    if (payload.srcset) {
      preload.setAttribute('imagesrcset', payload.srcset);
      preload.setAttribute('imagesizes', payload.sizes || IMG_SIZES);
    } else {
      preload.removeAttribute('imagesrcset');
      preload.removeAttribute('imagesizes');
    }
  }

  function syncHeroPreloadFromMainImg() {
    const mainImg = document.getElementById('mixersMainImg');
    if (!mainImg?.src) return;
    updateHeroPreload({
      src: mainImg.currentSrc || mainImg.src,
      srcset: mainImg.srcset || '',
      sizes: mainImg.sizes || IMG_SIZES,
    });
  }

  function waitForSpreadsheetUtils(timeoutMs) {
    return new Promise((resolve) => {
      if (typeof loadCsvData === 'function' && typeof displayDialog === 'function') {
        resolve(true);
        return;
      }
      const start = Date.now();
      const timer = setInterval(() => {
        if (typeof loadCsvData === 'function' && typeof displayDialog === 'function') {
          clearInterval(timer);
          resolve(true);
        } else if (Date.now() - start > (timeoutMs || 5000)) {
          clearInterval(timer);
          resolve(false);
        }
      }, 50);
    });
  }

  function initMixersCoa(root, getVariant) {
    const variantCoa = root.querySelector('variant-coa');
    const button = variantCoa && variantCoa.querySelector('button');
    if (!variantCoa || !button || variantCoa.dataset.mixersCoaInit === 'true') return null;

    variantCoa.dataset.mixersCoaInit = 'true';
    let coaData = [];
    const spreadsheet = variantCoa.getAttribute('data-spreadsheet');

    function updateCoa(variant) {
      if (!variant || !coaData.length) return;
      const sku = variant.sku || '';
      const row = coaData.find((x) => x.SKU && sku && String(x.SKU).includes(String(sku)));
      const wrap = variantCoa.closest('.kava-coa');
      if (row && row.URL) {
        variantCoa.style.display = 'block';
        button.dataset.url = row.URL;
        if (wrap) wrap.hidden = false;
      } else {
        variantCoa.style.display = 'none';
        delete button.dataset.url;
        if (wrap) wrap.hidden = true;
      }
    }

    waitForSpreadsheetUtils().then((ready) => {
      if (!ready || !spreadsheet) return;

      const dialog = document.querySelector('#coa-dialog');
      if (dialog) {
        const downloadBtn = dialog.querySelector('[data-role="download"]');
        const closeBtn = dialog.querySelector('[data-role="close"]');
        if (typeof hideCoaDialog === 'function') {
          dialog.addEventListener('click', hideCoaDialog({ dialog }));
          if (closeBtn) closeBtn.addEventListener('click', hideCoaDialog({ dialog }));
        }
        button.addEventListener('click', (e) => {
          e.preventDefault();
          if (!button.dataset.url || typeof displayDialog !== 'function') return;
          displayDialog({ input: button, dialog, downloadButton: downloadBtn });
        });
      }

      loadCsvData(spreadsheet)
        .then((data) => {
          coaData = data || [];
          updateCoa(getVariant());
        })
        .catch(() => {});
    });

    return { updateCoa };
  }

  function initMixersPdp(root) {
    if (!root || root.dataset.mixersInit === 'true') return;

    let data;
    try {
      data = JSON.parse(root.querySelector('[data-mixers-json]')?.textContent || '{}');
    } catch (e) {
      return;
    }

    const variants = data.variants || [];
    if (!variants.length) return;

    root.dataset.mixersInit = 'true';

    const moneyFormat = data.money_format || '${{amount}}';
    const subscribeDisc = parseFloat(data.subscribe_discount || 0.25);
    const bottleImg = data.bottle_image || '';

    const initialVariantId = data.initial_variant_id || variants[0].id;
    const initialVariant = variants.find((v) => String(v.id) === String(initialVariantId)) || variants[0];
    const canSubInitially = !!(initialVariant && initialVariant.selling_plan_id);
    const defaultPurchase = canSubInitially && root.dataset.defaultPurchase === 'sub' ? 'sub' : 'once';
    const state = {
      variantId: initialVariantId,
      qty: 1,
      qtyDisc: 0,
      type: defaultPurchase,
      typeDisc: defaultPurchase === 'sub' ? subscribeDisc : 0,
      adding: false,
    };

    const el = (sel) => root.querySelector(sel);
    const els = (sel) => Array.from(root.querySelectorAll(sel));

    function isAvailable(v) {
      if (!v) return false;
      if (typeof v.available === 'boolean') return v.available;
      const btn = root.querySelector('.mixers-flavor[data-variant-id="' + v.id + '"]');
      if (btn) return btn.dataset.available === 'true';
      return true;
    }

    function money(cents) {
      const n = (cents / 100).toFixed(2);
      return moneyFormat.replace('{{amount}}', n).replace('{{amount_no_decimals}}', Math.round(cents / 100));
    }

    function sellingPlanIdFor(variant) {
      return variant && variant.selling_plan_id ? variant.selling_plan_id : '';
    }

    function syncSubscriptionOption(variant) {
      const canSub = !!sellingPlanIdFor(variant);
      const subOpt = root.querySelector('.mixers-popt[data-type="sub"]');
      const purchaseBlock = subOpt ? subOpt.closest('.blk') : null;
      if (subOpt) subOpt.hidden = !canSub;
      if (purchaseBlock) purchaseBlock.hidden = !canSub;
      if (!canSub && state.type === 'sub') {
        state.type = 'once';
        state.typeDisc = 0;
        els('.mixers-popt').forEach((opt) => {
          opt.classList.toggle('active', opt.dataset.type === 'once');
        });
      }
    }

    function currentVariant() {
      return variants.find((v) => String(v.id) === String(state.variantId)) || variants[0];
    }

    function formatDiscountLabel(typeDisc, qtyDisc) {
      const labels = [];
      if (state.type === 'sub' && typeDisc > 0) {
        labels.push(Math.round(typeDisc * 100) + '%');
      }
      if (qtyDisc > 0) {
        labels.push(Math.round(qtyDisc * 100) + '%');
      }
      if (!labels.length) return '';
      if (labels.length === 1) return labels[0] + ' OFF';
      return labels.join(' + ') + ' OFF';
    }

    function calc(qty, qtyDisc, typeDisc) {
      const v = currentVariant();
      const unit = v.price;
      const gross = unit * qty;
      const net = Math.round(gross * (1 - qtyDisc) * (1 - typeDisc));
      return { gross, net, unit };
    }

    function setBottles(isCitrus) {
      els('.qb').forEach((img) => {
        img.src = isCitrus ? (data.bottle_citrus || bottleImg) : (data.bottle_unflavored || bottleImg);
        img.alt = '';
      });
    }

    function normalizeTag(tag) {
      return String(tag || '').toLowerCase().trim().replace(/\s+/g, '-');
    }

    function imagesForVariant(variant) {
      const gallery = data.gallery || [];
      if (!gallery.length) return [];

      const flavorKey = normalizeTag(variant.flavor_key);
      const flavorLabel = normalizeTag(variant.flavor_label || variant.title);

      const matches = gallery.filter((img) => {
        const tags = (img.tags || []).map(normalizeTag).filter(Boolean);
        if (!tags.length || tags.includes('all') || tags.includes('shared')) return true;
        if (tags.includes(flavorKey) || tags.includes(flavorLabel)) return true;
        return tags.some((tag) => flavorLabel.includes(tag) || flavorKey.includes(tag));
      });

      if (!matches.length) return gallery;

      const featuredId = variant.featured_media_id != null ? String(variant.featured_media_id) : '';
      return matches.slice().sort((a, b) => {
        const aFeatured = featuredId && String(a.id) === featuredId;
        const bFeatured = featuredId && String(b.id) === featuredId;
        if (aFeatured !== bFeatured) return aFeatured ? -1 : 1;

        const aShared = !(a.tags || []).length || (a.tags || []).some((t) => ['all', 'shared'].includes(normalizeTag(t)));
        const bShared = !(b.tags || []).length || (b.tags || []).some((t) => ['all', 'shared'].includes(normalizeTag(t)));
        if (aShared !== bShared) return aShared ? 1 : -1;

        return 0;
      });
    }

    function setMainImage(mainImg, payload) {
      if (!mainImg || !payload) return;
      mainImg.src = payload.src || '';
      mainImg.alt = payload.alt || '';
      if (payload.mediaId) mainImg.dataset.mediaId = payload.mediaId;
      if (payload.srcset) {
        mainImg.srcset = payload.srcset;
        mainImg.sizes = payload.sizes || IMG_SIZES;
      } else {
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
      }
      updateHeroPreload(payload);
    }

    function imagePayloadFromData(img, variant) {
      return {
        src: img.src,
        srcset: img.srcset || '',
        sizes: img.sizes || IMG_SIZES,
        alt: img.alt || variant.title,
        mediaId: img.id || '',
      };
    }

    function imagePayloadFromThumb(thumbBtn, variant) {
      return {
        src: thumbBtn.dataset.src || '',
        srcset: thumbBtn.dataset.srcset || '',
        sizes: thumbBtn.dataset.sizes || IMG_SIZES,
        alt: thumbBtn.dataset.alt || variant.title,
        mediaId: thumbBtn.dataset.mediaId || '',
      };
    }

    function bindThumbClicks() {
      const thumbsWrap = el('#mixersThumbs');
      const mainImg = el('#mixersMainImg');
      if (!thumbsWrap || !mainImg || thumbsWrap.dataset.bound === 'true') return;
      thumbsWrap.dataset.bound = 'true';
      thumbsWrap.addEventListener('click', (e) => {
        const t = e.target.closest('.thumb');
        if (!t) return;
        setMainImage(mainImg, imagePayloadFromThumb(t, currentVariant()));
        thumbsWrap.querySelectorAll('.thumb').forEach((x) => x.classList.remove('active'));
        t.classList.add('active');
      });
    }

    function buildGallery(variant) {
      const mainImg = el('#mixersMainImg');
      const thumbsWrap = el('#mixersThumbs');
      if (!mainImg || !thumbsWrap) return;

      const images = imagesForVariant(variant);
      if (!images.length) return;

      setMainImage(mainImg, imagePayloadFromData(images[0], variant));
      thumbsWrap.innerHTML = '';

      images.forEach((img, i) => {
        const t = document.createElement('button');
        t.type = 'button';
        t.className = 'thumb' + (i === 0 ? ' active' : '');
        t.setAttribute('aria-label', 'View image ' + (i + 1));
        t.dataset.mediaId = img.id || '';
        t.dataset.src = img.src;
        t.dataset.srcset = img.srcset || '';
        t.dataset.sizes = img.sizes || IMG_SIZES;
        t.dataset.alt = img.alt || variant.title;
        t.innerHTML = '<img src="' + (img.thumb || img.src) + '" alt="' + (img.alt || '').replace(/"/g, '&quot;') + '" loading="lazy" width="72" height="72">';
        thumbsWrap.appendChild(t);
      });
    }

    function openLightbox() {
      const lb = document.getElementById('mixersLightbox');
      const grid = document.getElementById('mixersLbGrid');
      const v = currentVariant();
      const images = imagesForVariant(v);
      if (!lb || !grid) return;
      grid.innerHTML = images.map((img) => '<img src="' + img.src + '" alt="' + (img.alt || '').replace(/"/g, '&quot;') + '">').join('');
      lb.classList.add('open');
      lb.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      const lb = document.getElementById('mixersLightbox');
      if (!lb) return;
      lb.classList.remove('open');
      lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function applyVariant(variant, options) {
      const opts = options || {};
      const prevVariantId = state.variantId;
      state.variantId = variant.id;

      const lede = el('#mixersLede');
      const ingBody = el('#mixersIngBody');
      const pick = el('#mixersFlavorPick');
      const input = el('#mixersVariantId');
      const cta = el('#mixersCtaBtn');

      if (lede) {
        lede.textContent = variant.lede || '';
        lede.hidden = !variant.lede;
      }
      if (ingBody) ingBody.innerHTML = variant.ingredients || '';
      if (pick) pick.textContent = variant.flavor_label || variant.title;
      if (input) input.value = variant.id;

      syncSubscriptionOption(variant);

      if (cta && !isAvailable(variant)) {
        cta.disabled = true;
        cta.textContent = 'Sold Out';
      }

      const isCitrus = (variant.flavor_key || '').toLowerCase() === 'citrus';
      setBottles(isCitrus);

      const variantChanged = String(prevVariantId) !== String(variant.id);
      const thumbsWrap = el('#mixersThumbs');
      const hasServerThumbs = !variantChanged && !opts.forceGallery && thumbsWrap && thumbsWrap.children.length > 0;

      if (!hasServerThumbs) {
        buildGallery(variant);
      }

      if (!opts.skipUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.href);
      }

      document.dispatchEvent(new CustomEvent('mixers:flavorchange', { detail: { variant } }));
      if (coaApi) coaApi.updateCoa(variant);
    }

    function render() {
      const sub = calc(state.qty, state.qtyDisc, subscribeDisc);
      const once = calc(state.qty, state.qtyDisc, 0);
      const cur = calc(state.qty, state.qtyDisc, state.typeDisc);
      const v = currentVariant();

      const subPrice = el('#mixersSubPrice');
      const oncePrice = el('#mixersOncePrice');
      if (subPrice) subPrice.innerHTML = money(sub.net) + '<s>' + money(once.gross) + '</s>';
      if (oncePrice) oncePrice.innerHTML = money(once.net) + (state.qtyDisc > 0 ? '<s>' + money(once.gross) + '</s>' : '');

      const showSavings = cur.net < once.gross;
      const nowPrice = el('#mixersNowPrice');
      const wasPrice = el('#mixersWasPrice');
      const offTag = el('#mixersOffTag');
      const perBottle = el('#mixersPerBottle');
      const cta = el('#mixersCtaBtn');
      const qtyPick = el('#mixersQtyPick');

      if (nowPrice) nowPrice.textContent = money(cur.net);
      if (wasPrice) {
        wasPrice.textContent = money(once.gross);
        wasPrice.style.display = showSavings ? 'inline' : 'none';
      }
      if (offTag) {
        const label = formatDiscountLabel(state.typeDisc, state.qtyDisc);
        offTag.textContent = label;
        offTag.style.display = label ? 'inline' : 'none';
      }
      if (perBottle) {
        perBottle.textContent = money(Math.round(cur.net / state.qty)) + ' per bottle · ' + (v.flavor_label || v.title) + ' · ' + state.qty + ' bottle' + (state.qty > 1 ? 's' : '');
      }
      if (qtyPick) qtyPick.textContent = state.qty + ' bottle' + (state.qty > 1 ? 's' : '');
      if (cta) {
        const label = state.type === 'sub' ? (data.cta_subscribe_label || 'Subscribe & Save') : (data.cta_onetime_label || 'Add to Cart');
        if (state.adding) {
          cta.textContent = 'Adding…';
        } else if (!isAvailable(v)) {
          cta.textContent = 'Sold Out';
        } else {
          cta.textContent = label + ' — ' + money(cur.net);
        }
        cta.disabled = state.adding || !isAvailable(v);
      }

      const qtyInput = el('#mixersQtyInput');
      if (qtyInput) qtyInput.value = state.qty;

      const planInput = el('#mixersSellingPlan');
      const planId = state.type === 'sub' ? sellingPlanIdFor(v) : '';
      if (planInput) {
        if (planId) {
          planInput.disabled = false;
          planInput.name = 'selling_plan';
          planInput.value = planId;
        } else {
          planInput.value = '';
          planInput.disabled = true;
          planInput.removeAttribute('name');
        }
      }
    }

    async function addToCart(form) {
      render();
      const formData = new FormData(form);
      if (window.CART?.add) {
        await window.CART.add(formData);
        return;
      }

      if (!formData.get('selling_plan')) formData.delete('selling_plan');
      const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
      const payload = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(payload.description || payload.message || 'Could not add to cart');
      }
      document.dispatchEvent(new CustomEvent('oasis:cart:update'));
      document.dispatchEvent(new CustomEvent('oasis:cart:open'));
    }

    els('.mixers-flavor').forEach((card) => {
      card.addEventListener('click', () => {
        const id = card.dataset.variantId;
        const variant = variants.find((v) => String(v.id) === String(id));
        if (!variant) return;
        els('.mixers-flavor').forEach((x) => x.classList.remove('active'));
        card.classList.add('active');
        applyVariant(variant);
        render();
      });
    });

    els('.mixers-qopt').forEach((opt) => {
      opt.addEventListener('click', () => {
        els('.mixers-qopt').forEach((x) => x.classList.remove('active'));
        opt.classList.add('active');
        state.qty = parseInt(opt.dataset.qty, 10) || 1;
        state.qtyDisc = parseFloat(opt.dataset.disc || 0);
        render();
      });
    });

    els('.mixers-popt').forEach((opt) => {
      opt.addEventListener('click', () => {
        els('.mixers-popt').forEach((x) => x.classList.remove('active'));
        opt.classList.add('active');
        state.type = opt.dataset.type;
        state.typeDisc = opt.dataset.type === 'sub' ? subscribeDisc : 0;
        render();
      });
    });

    const form = el('#mixersProductForm');
    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (state.adding || !isAvailable(currentVariant())) return;
        state.adding = true;
        render();
        try {
          await addToCart(form);
        } catch (err) {
          alert(err.message || 'Could not add to cart');
        } finally {
          state.adding = false;
          render();
        }
      });
    }

    const mainImgEl = el('#mixersMainImg');
    if (mainImgEl) {
      mainImgEl.style.cursor = 'zoom-in';
      mainImgEl.addEventListener('click', openLightbox);
    }

    const lbClose = document.getElementById('mixersLbClose');
    const lb = document.getElementById('mixersLightbox');
    if (lbClose) lbClose.addEventListener('click', closeLightbox);
    if (lb) lb.addEventListener('click', (e) => { if (e.target === lb) closeLightbox(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeLightbox(); });

    const initial = variants.find((v) => String(v.id) === String(state.variantId)) || variants[0];
    const coaApi = initMixersCoa(root, () => currentVariant());
    applyVariant(initial, { skipUrl: true });
    bindThumbClicks();
    render();
    syncHeroPreloadFromMainImg();
  }

  function bootMixersPdp(scope) {
    const container = scope || document;
    container.querySelectorAll('[data-mixers-pdp]').forEach((root) => {
      if (root.dataset.mixersInit === 'true') return;
      initMixersPdp(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bootMixersPdp());
  } else {
    bootMixersPdp();
  }

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-mixers-pdp]').forEach((root) => {
      delete root.dataset.mixersInit;
      const thumbs = root.querySelector('#mixersThumbs');
      if (thumbs) delete thumbs.dataset.bound;
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    bootMixersPdp(event.target);
    if (event.target.querySelector('[data-mixers-pdp]')) {
      syncHeroPreloadFromMainImg();
    }
  });
})();

(function () {
  const recipes = document.querySelector('[data-mixers-recipes]');
  if (!recipes) return;

  const grid = recipes.querySelector('#mixersRgrid');
  const dotsWrap = recipes.querySelector('#mixersRdots');

  function visibleCards() {
    if (!grid) return [];
    return Array.prototype.filter.call(grid.querySelectorAll('.rcard'), (c) => c.style.display !== 'none');
  }

  function buildDots() {
    if (!grid || !dotsWrap) return;
    const cards = visibleCards();
    dotsWrap.innerHTML = '';
    cards.forEach((c, i) => {
      const d = document.createElement('span');
      d.className = 'dot' + (i === 0 ? ' active' : '');
      d.addEventListener('click', () => c.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }));
      dotsWrap.appendChild(d);
    });
  }

  function updateActiveDot() {
    if (!grid || !dotsWrap) return;
    const cards = visibleCards();
    if (!cards.length) return;
    const gridRect = grid.getBoundingClientRect();
    const gridCenter = gridRect.left + gridRect.width / 2;
    let idx = 0;
    let min = Infinity;
    cards.forEach((c, i) => {
      const r = c.getBoundingClientRect();
      const diff = Math.abs((r.left + r.width / 2) - gridCenter);
      if (diff < min) { min = diff; idx = i; }
    });
    dotsWrap.querySelectorAll('.dot').forEach((dt, i) => dt.classList.toggle('active', i === idx));
  }

  recipes.querySelectorAll('.rfilter button').forEach((btn) => {
    btn.addEventListener('click', () => {
      recipes.querySelectorAll('.rfilter button').forEach((x) => x.classList.remove('active'));
      btn.classList.add('active');
      const f = btn.dataset.filter;
      grid.querySelectorAll('.rcard').forEach((c) => {
        c.style.display = (f === 'all' || c.dataset.base === f) ? 'flex' : 'none';
      });
      if (grid) grid.scrollLeft = 0;
      buildDots();
    });
  });

  buildDots();
  if (grid) {
    let ticking = false;
    grid.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => { updateActiveDot(); ticking = false; });
        ticking = true;
      }
    });
  }
  window.addEventListener('resize', updateActiveDot);

  document.addEventListener('mixers:flavorchange', (e) => {
    const key = (e.detail?.variant?.flavor_key || '').toLowerCase();
    if (!key) return;
    const btn = recipes.querySelector('.rfilter button[data-filter="' + key + '"]');
    if (btn) btn.click();
  });
})();
